import React, { useState } from "react";
import firebase from "firebase/app";

export default function CookieBanner() {
  const [visible, setVisible] = useState(
    () => !window.localStorage.getItem("cookie_consent")
  );

  if (!visible) return null;

  const accept = () => {
    window.localStorage.setItem("cookie_consent", "accepted");
    try {
      firebase.analytics();
    } catch (e) {
      // analytics SDK not loaded — non-critical
    }
    setVisible(false);
  };

  const reject = () => {
    window.localStorage.setItem("cookie_consent", "rejected");
    setVisible(false);
  };

  return (
    <>
      <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
        <div className="cookie-banner-inner">
          <h2 className="cookie-banner-heading">Cookies</h2>
          <p className="cookie-banner-text">
            We use cookies to understand how visitors use our site so we can
            improve the experience. You may accept or reject non-essential
            cookies below. Essential cookies required for the site to function
            (such as authentication) are always active. See our{" "}
            <a href="/Piatto_Privacy_Policy.html" className="cookie-banner-link">
              Privacy Policy
            </a>{" "}
            for more information.
          </p>
          <div className="cookie-banner-buttons">
            <button className="cookie-btn cookie-btn-accept" onClick={accept}>
              Accept all cookies
            </button>
            <button className="cookie-btn cookie-btn-reject" onClick={reject}>
              Reject non-essential
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .cookie-banner {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 9999;
          background: rgba(24, 24, 27, 0.97);
          backdrop-filter: blur(8px);
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          animation: cookie-slide-up 0.4s ease-out;
        }
        @keyframes cookie-slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        .cookie-banner-inner {
          max-width: 960px;
          margin: 0 auto;
          padding: 28px 24px 24px;
        }
        .cookie-banner-heading {
          font-family: "Atkinson Hyperlegible Next", "Lexend", sans-serif;
          font-size: 1.25rem;
          font-weight: 700;
          color: #fff;
          margin: 0 0 12px;
        }
        .cookie-banner-text {
          font-family: "Atkinson Hyperlegible Next", "Lexend", sans-serif;
          font-size: 0.95rem;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.82);
          margin: 0 0 20px;
        }
        .cookie-banner-link {
          color: #93c5fd;
          text-decoration: underline;
        }
        .cookie-banner-link:hover {
          color: #bfdbfe;
        }
        .cookie-banner-buttons {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
        .cookie-btn {
          font-family: "Atkinson Hyperlegible Next", "Lexend", sans-serif;
          font-size: 0.95rem;
          font-weight: 600;
          padding: 12px 28px;
          border-radius: 8px;
          cursor: pointer;
          border: 2px solid #fff;
          transition: background 0.15s, color 0.15s;
        }
        .cookie-btn-accept {
          background: #fff;
          color: #18181b;
        }
        .cookie-btn-accept:hover {
          background: #e4e4e7;
        }
        .cookie-btn-reject {
          background: transparent;
          color: #fff;
          border-color: rgba(255, 255, 255, 0.4);
        }
        .cookie-btn-reject:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        @media (max-width: 600px) {
          .cookie-banner-inner {
            padding: 20px 16px 18px;
          }
          .cookie-banner-buttons {
            flex-direction: column;
          }
          .cookie-btn {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>
    </>
  );
}
